import type { FCWithChildren } from '@pbk-web/types';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

import ErrorPage from './components/error/ErrorPage';
import { AutoLayout } from './layouts/Layout';
import ErrorType from './models/Error';

type Props = {
  currentUser?: { id: string } | null;
  currentClient?: { id: string } | null;
};

const { UNKNOWN_ERROR, APP_UPDATED } = ErrorType;

const PbkErrorBoundary: FCWithChildren<Props> = (props) => {
  const { currentUser, currentClient, children } = props;

  return (
    <SentryErrorBoundary
      beforeCapture={(scope) => {
        scope.setUser({
          id: currentUser?.id,
          clientId: currentClient?.id,
        });
        return scope;
      }}
      fallback={(props) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isAppUpdated = (props.error as any).message.includes('Failed to fetch dynamically imported module');
        return (
          <AutoLayout>
            <ErrorPage
              type={isAppUpdated ? APP_UPDATED : UNKNOWN_ERROR}
              showRefresh
              showContactSupport
              goBackCallback={() => {
                const timeout = setTimeout(() => {
                  props.resetError();
                  clearTimeout(timeout);
                }, 500);
              }}
            />
          </AutoLayout>
        );
      }}
    >
      {children}
    </SentryErrorBoundary>
  );
};

export default PbkErrorBoundary;
